import React from "react";
import { Modal, Button } from "react-bootstrap";
import MedicalInvoiceContainer from "./MedicalInvoice"; // Adjust path if needed

interface InvoiceModalProps {
  show: boolean;
  onHide: () => void;
  appointmentId: string;
  invoiceDone: boolean | undefined | null;
}

const InvoiceModal: React.FC<InvoiceModalProps> = ({
  show,
  onHide,
  appointmentId,
  invoiceDone,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Invoice </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MedicalInvoiceContainer
          appointmentId={appointmentId}
          invoiceDone={invoiceDone}
          closeFn={onHide}
        />
      </Modal.Body>
    </Modal>
  );
};

export default InvoiceModal;
